module.exports = __webpack_public_path__ + "img/image152.0eec4079.png";